@if (step) {
  <div [joyrideStep]="step.id" [text]="step.text" [title]="step.title">
    <ng-content></ng-content>
  </div>
}
